module.exports = __webpack_public_path__ + "holi2.png?c5e8ab91c7275c3449e404f4beccafe5";


//////////////////
// WEBPACK FOOTER
// ./public/img/memories/holi2.png
// module id = 576
// module chunks = 1